"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerticalList = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const cotopaxi_1 = require("@as/cotopaxi");
const list_utils_1 = require("./list.utils");
const ListItemContent_1 = require("./ListItemContent");
const VerticalList = ({ items, listType }) => ((0, jsx_runtime_1.jsx)(cotopaxi_1.List, { type: listType === 'none' ? undefined : listType, children: items.map((item, key) => ((0, jsx_runtime_1.jsxs)(cotopaxi_1.List.Item, { children: [(0, jsx_runtime_1.jsx)(ListItemContent_1.ListItemContent, { item: item }), !!item.borderBottom && (0, jsx_runtime_1.jsx)(cotopaxi_1.Divider, { lineColor: list_utils_1.mapTextColorToDividerLineColor[item.textColor] })] }, `list-item-${key}`))) }));
exports.VerticalList = VerticalList;
